module.exports = __webpack_public_path__ + "img/group-3@2x.df2aefa5.png";